export default "__VITE_ASSET__DLjIkjKU__ 640w, __VITE_ASSET__BQsKrFdW__ 1024w, __VITE_ASSET__kZCu$6fZ__ 1280w";